import type { ThemeId } from '@otter/shared';

export const THEMES: Array<{
  id: ThemeId;
  label: string;
  mode: 'dark' | 'light';
  swatch: [string, string, string, string];
  desc: string;
}> = [
  {
    id: 'dark-lima',
    label: 'Dark · Lima',
    mode: 'dark',
    swatch: ['#0e0f12', '#16181c', '#c8f25c', '#76746e'],
    desc: 'el original — verde lima sobre grafito',
  },
  {
    id: 'dark-cobalto',
    label: 'Dark · Cobalto',
    mode: 'dark',
    swatch: ['#0e0f12', '#16181c', '#6e8aff', '#76746e'],
    desc: 'mismo dark pero acento azul',
  },
  {
    id: 'light-cobalto',
    label: 'Light · Cobalto',
    mode: 'light',
    swatch: ['#ffffff', '#fbfaf7', '#1f3df5', '#7a7770'],
    desc: 'modo claro · azul eléctrico',
  },
  {
    id: 'light-lima',
    label: 'Light · Lima',
    mode: 'light',
    swatch: ['#ffffff', '#fbfaf7', '#6f8a18', '#7a7770'],
    desc: 'modo claro · oliva sobre blanco',
  },
];

export function applyTheme(theme: ThemeId): void {
  document.documentElement.className = `theme-${theme}`;
  document.cookie = `otter_theme_hint=${encodeURIComponent(theme)}; path=/; max-age=${365 * 24 * 60 * 60}; SameSite=Lax`;
}
